exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-date-picker .igx-dialog__window{max-width:340px;min-width:320px;padding:0}.igx-date-picker .igx-dialog__window,.igx-date-picker .igx-dialog__window-content{width:100%;padding:0;color:inherit;font-size:medium;line-height:normal}.igx-date-picker .igx-dialog__window-title{display:none}.igx-date-picker .igx-dialog__window-actions{margin:0}.igx-date-picker .igx-calendar__body{padding-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/date-picker/date-picker.component.scss
// module id = 145
// module chunks = 0 1